import React from 'react';
import { WorkiumLogo } from './WorkiumLogo';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-800 pt-16 pb-8" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="flex flex-col md:flex-row items-start justify-between gap-12 mb-16" data-id="element-118">
          {/* Left Column */}
          <div data-id="element-119">
            <div className="mb-4" data-id="element-120">
              <WorkiumLogo size="md" data-id="element-121" />
            </div>
            <p className="text-slate-400 text-sm" data-id="element-122">
              Orchestrate smarter. Ship faster.
            </p>
          </div>

          {/* Legal Links */}
          <div data-id="element-123">
            <h4 className="text-slate-100 font-semibold mb-4" data-id="element-124">Legal</h4>
            <ul className="space-y-3" data-id="element-125">
              <li data-id="element-126">
                <a href="https://demo.workium.ai/privacy" className="text-slate-400 hover:text-indigo-400 text-sm transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-127">
                  Privacy
                </a>
              </li>
              <li data-id="element-128">
                <a href="https://demo.workium.ai/terms" className="text-slate-400 hover:text-indigo-400 text-sm transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-129">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-130">
          <p className="text-slate-500 text-sm" data-id="element-131">
            © 2026 Workium AI. All rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-132">
            <a href="https://demo.workium.ai/privacy" className="text-slate-500 hover:text-white text-sm transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-133">
              Privacy
            </a>
            <span className="text-slate-700" data-id="element-134">·</span>
            <a href="https://demo.workium.ai/terms" className="text-slate-500 hover:text-white text-sm transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-135">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}